import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UserReducer extends Partial<User> {
  token: string
  exp: string
  confirmed: boolean
  name: string
  email: string
  address: string
  role: RolesUnion | null
  user_id?: string
  ui_setting?: Partial<UiSettings>
}

export const initialState: UserReducer = {
  token: '',
  exp: '',
  confirmed: false,
  name: '',
  email: '',
  address: '',
  role: null,
  ui_setting: {}
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, { payload }: PayloadAction<Partial<User>>): UserReducer => ({
      ...state,
      ...payload
    }),

    logout: (): UserReducer => initialState
  }
})

export const { login, logout } = userSlice.actions

export default userSlice.reducer
